export default __webpack_public_path__ + "navigation-examples-basic-v1-960-56a651f9586d6b89c80856a8dd22daec.webp";